import { TFunction } from 'react-i18next';

import { getRatingConfig } from 'hooks/useRatingConfig';

export const getGuestRatingLabel = (
    key: string,
    value: number,
    t: TFunction
) => {
    return `${t(key)}: ${value}+`;
};
export const buildGuestRatingLabel = (value: string, t: TFunction) => {
    const key = parseInt(value);
    const ratingConfig = getRatingConfig();
    const currentRating = ratingConfig.filterThresholds.find((el) => {
        return key === el.threshold;
    });

    const labelKey = currentRating?.labelKey ?? 'TRANS';

    return getGuestRatingLabel(labelKey, key, t);
};
